var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.container},_vm._l((_vm.meshTree),function(item,key){return _c('MeshTreeItem',_vm._g({key:key,attrs:{"tree":item,"level":1,"path":key,"activeMeshTreePaths":_vm.activeMeshTreePaths,"selectedPaths":_vm.selectedPaths}},_vm.$listeners))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }